/**
 * Loại dự toán thu
 */
export default {
  BuPlanReceiptBudget: 152, // 'Dự toán thu đầu năm theo MLNS',
  BuPlanReceiptBudgetAdd: 153, // 'Dự toán thu bổ sung theo MLNS',
  BuPlanReceiptBudgetSupplement: 321, // 'Dự toán thu điều chỉnh theo MLNS',
  BuPlanReceiptActivity: 997, // 'Dự toán thu đầu năm theo NDKT
  BuPlanReceiptActivitySupplement: 998, // 'Dự toán thu bổ sung theo NDKT
  BuPlanReceiptActivityAdjust: 999, // 'Dự toán thu điều chỉnh theo NDKT
};
